import { EditOutlined, LoadingOutlined } from "@ant-design/icons";
import { Button, Col, Form, Row, Select, Space, Spin, Typography } from "antd";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";

import AppContainer from "~v2/components/AppContainer/AppContainer";
import Notification from "../../../components/shared/Notification";
import { COLORS } from "../../../constants";
import { getOptions } from "../../../helpers/options";
import { getEstablishment } from "../../http-request/establishment";
import { updateUser } from "../../http-request/user";
import styles from "./styles/AccountPage.module.css";
const { Paragraph } = Typography;
const ManageAccountPageEdit = () => {
  const locationData = useLocation().state;
  const navigate = useNavigate();
  const { id } = useParams();
  const [establishments, setEstablishments] = useState([]);
  const [isLoading, setisLoading] = useState(false);

  useEffect(() => {
    if (!locationData && !id) {
      Notification("Error", "No page data found!", "error");
      navigate(-1);
    }
    loadEstablishment();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [locationData, id]);

  const loadEstablishment = async () => {
    await getEstablishment().then(({ establishments }) => {
      let _data = getOptions({
        data: establishments,
        value: "_id",
        label: "name",
      });
      setEstablishments(_data);
    });
  };

  const antIcon = (
    <LoadingOutlined style={{ fontSize: 20, color: COLORS.blue1 }} spin />
  );

  return (
    <AppContainer title="User Account Details">
      <div className={styles.container}>
        <center>
          <div className={styles.content}>
            <div className={styles.info}>
              <Form
                initialValues={{
                  establishment: locationData.establishments[0].name,
                }}
                onFinish={async (data) => {
                  setisLoading(true);
                  const _establishment = establishments.find(
                    (establishment) =>
                      establishment.label === data.establishment
                  );
                  data = {
                    _id: id,
                    establishments: [
                      {
                        estId: _establishment.value,
                        name: _establishment.label,
                      },
                    ],
                  };

                  await updateUser(data)
                    .then((data) => {
                      if (data?.didUpdate) {
                        Notification(
                          "User successfully updated!",
                          "",
                          "success"
                        );
                        navigate(-1, { replace: true });
                      }
                    })
                    .finally(() => setisLoading(false));
                }}
              >
                <Space
                  direction="vertical"
                  size={"middle"}
                  style={{ width: "100%" }}
                >
                  <div className={styles.info}>

                  <Row gutter={10}>
                    <Col span={8}>
                      <Paragraph strong style={{ textAlign: "left" }} ellipsis>
                        User Type:
                      </Paragraph>
                    </Col>
                    <Col span={14}>
                      <Paragraph style={{ textAlign: "left" }}>
                        {locationData.usertype}
                      </Paragraph>
                    </Col>
                  </Row>
                  <Row gutter={10}>
                    <Col span={8}>
                      <Paragraph strong style={{ textAlign: "left" }} ellipsis>
                        Name:
                      </Paragraph>
                    </Col>
                    <Col span={12}>
                      <Paragraph style={{ textAlign: "left" }}>
                        {locationData.firstname} {locationData.lastname}
                      </Paragraph>
                    </Col>
                  </Row>

                  <Row gutter={10}>
                    <Col span={8}>
                      <Paragraph strong style={{ textAlign: "left" }} ellipsis>
                        Email:
                      </Paragraph>
                    </Col>
                    <Col span={14}>
                      <Paragraph style={{ textAlign: "left" }}>
                        {locationData.email}
                      </Paragraph>
                    </Col>
                  </Row>
                  <Row gutter={10}>
                    <Col span={8}>
                      <Paragraph strong style={{ textAlign: "left" }} ellipsis>
                        Phone Number:
                      </Paragraph>
                    </Col>
                    <Col span={14}>
                      <Paragraph style={{ textAlign: "left" }}>
                        {locationData.phonenumber}
                      </Paragraph>
                    </Col>
                  </Row>
                  <Row gutter={10}>
                    <Col span={8}>
                      <Paragraph strong style={{ textAlign: "left" }} ellipsis>
                        Sex:
                      </Paragraph>
                    </Col>
                    <Col span={14}>
                      <Paragraph style={{ textAlign: "left" }}>
                        {locationData.gender}
                      </Paragraph>
                    </Col>
                  </Row>
                  <Row gutter={10}>
                    <Col span={8}>
                      <Paragraph strong className={styles.textLeft} ellipsis>
                        TRE Affiliation:
                      </Paragraph>
                    </Col>
                    <Col span={14} style={{ textAlign: "left" }}>
                      {locationData.usertype === "TRE" ? (
                        <Form.Item name={"establishment"} style={{ margin: 0 }}>
                          <Select options={establishments} />
                        </Form.Item>
                      ) : (
                        <Paragraph
                          strong
                          style={{ textAlign: "left" }}
                          ellipsis
                        >
                          {locationData.usertype}
                        </Paragraph>
                      )}
                    </Col>
                  </Row>
                  {locationData.usertype !== "Administrator" && (
                    <Row gutter={10}>
                      <Col span={22}>
                        <Button
                          disabled={isLoading}
                          htmlType="submit"
                          block
                          type="primary"
                          icon={!isLoading && <EditOutlined />}
                        >
                          {isLoading ? (
                            <Spin indicator={antIcon} />
                          ) : (
                            "UPDATE ACCOUNT"
                          )}
                        </Button>
                      </Col>
                    </Row>
                  )}
                  </div>
                </Space>
              </Form>
            </div>
          </div>
        </center>
      </div>
    </AppContainer>
  );
};

export default ManageAccountPageEdit;
